// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".detection-label[data-v-5791c45b]{border-radius:.3em;display:inline-block;-webkit-user-select:none;-moz-user-select:none;user-select:none;word-break:break-word}.detection-label__content[data-v-5791c45b]{border-radius:.3em;cursor:pointer;font-size:.8em;font-weight:500;line-height:1.4em;padding:0 .6em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
